export interface FlatDisplayAttribute {
  id: string;
  icon: string;
  library:
    | "EMOJIE"
    | "FontAwesome5"
    | "MaterialCommunityIcons"
    | "MaterialIcons";
}

export const FlatAttributes: FlatDisplayAttribute[] = [
  { id: "0", icon: "🌈", library: "EMOJIE" }, // DO NOT USE ICON BUT EMOJIE TO MAKE IT STAND OUT
  { id: "1", icon: "home", library: "FontAwesome5" }, // Studio
  { id: "2", icon: "dog", library: "FontAwesome5" }, // Pet Friendly
  { id: "3", icon: "elevator", library: "MaterialCommunityIcons" }, // Elevator
  { id: "4", icon: "car", library: "FontAwesome5" }, // Parking
  { id: "5", icon: "seedling", library: "FontAwesome5" }, // Garden
  { id: "6", icon: "balcony", library: "MaterialCommunityIcons" }, // Balcony
  { id: "7", icon: "wheelchair", library: "FontAwesome5" }, // Wheelchair Accessible
  { id: "8", icon: "dishwasher", library: "MaterialCommunityIcons" }, // Dishwasher
  { id: "9", icon: "fireplace", library: "MaterialCommunityIcons" }, // Fireplace
  { id: "10", icon: "wifi", library: "FontAwesome5" }, // Wifi
  { id: "11", icon: "washing-machine", library: "MaterialCommunityIcons" }, // Washing Machine
  { id: "12", icon: "air-conditioner", library: "MaterialCommunityIcons" }, // Air Conditioning
  { id: "13", icon: "bathtub", library: "MaterialCommunityIcons" }, // Bathtub
  { id: "14", icon: "tv", library: "FontAwesome5" }, // TV
  { id: "15", icon: "city", library: "FontAwesome5" }, // City Center
  { id: "16", icon: "recycle", library: "FontAwesome5" }, // Recycling
  { id: "17", icon: "dumbbell", library: "FontAwesome5" }, // Gym
  { id: "18", icon: "pool", library: "MaterialCommunityIcons" }, // Swimming Pool
  { id: "19", icon: "store", library: "MaterialCommunityIcons" }, // Shops Nearby
  { id: "20", icon: "subway", library: "MaterialCommunityIcons" }, // Public Transport
];

// Flat attributes with emojis and labels for webapp
export interface WebFlatAttribute {
  id: number;
  key: string;
  emoji: string;
  label: string;
}

export const FLAT_ATTRIBUTES: WebFlatAttribute[] = [
  { id: 0, key: "lgbtq_friendly", emoji: "🌈", label: "LGBTQ+ Friendly" },
  { id: 1, key: "studio", emoji: "🏠", label: "Studio" },
  { id: 2, key: "pet_friendly", emoji: "🐕", label: "Pet Friendly" },
  { id: 3, key: "elevator", emoji: "🛗", label: "Elevator" },
  { id: 4, key: "parking", emoji: "🚗", label: "Parking" },
  { id: 5, key: "garden", emoji: "🌱", label: "Garden" },
  { id: 6, key: "balcony", emoji: "🌅", label: "Balcony" },
  { id: 7, key: "wheelchair", emoji: "♿", label: "Wheelchair Accessible" },
  { id: 8, key: "dishwasher", emoji: "🍽️", label: "Dishwasher" },
  { id: 9, key: "fireplace", emoji: "🔥", label: "Fireplace" },
  { id: 10, key: "wifi", emoji: "📶", label: "WiFi" },
  { id: 11, key: "washing_machine", emoji: "🧺", label: "Washing Machine" },
  { id: 12, key: "air_conditioning", emoji: "❄️", label: "Air Conditioning" },
  { id: 13, key: "bathtub", emoji: "🛁", label: "Bathtub" },
  { id: 14, key: "tv", emoji: "📺", label: "TV" },
  { id: 15, key: "city_center", emoji: "🏙️", label: "City Center" },
  { id: 16, key: "recycling", emoji: "♻️", label: "Recycling" },
  { id: 17, key: "gym", emoji: "💪", label: "Gym" },
  { id: 18, key: "swimming_pool", emoji: "🏊", label: "Swimming Pool" },
  { id: 19, key: "shops_nearby", emoji: "🛒", label: "Shops Nearby" },
  { id: 20, key: "public_transport", emoji: "🚇", label: "Public Transport" },
];
